export const COPILOT_PROMPT_EXPLANATION =
  "Paste this into GitHub Copilot chat or the Copilot CLI prompt — not into a normal bash or zsh prompt.";

function quoteCopilotArgument(value: string): string {
  const normalized = value
    .replace(/\r\n|\r|\n/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  return JSON.stringify(normalized);
}

export function buildRequestFormulatorCommand(
  idea = "Describe the idea you want to propose",
): string {
  return `@request-formulator ${quoteCopilotArgument(idea)}`;
}

export function buildPlannerCommand(
  description = "Describe what you want to build",
): string {
  return `@planner ${quoteCopilotArgument(description)}`;
}

export function buildPlannerFromRequestCommand(title: string): string {
  return `@planner --from-request ${quoteCopilotArgument(title)}`;
}

export function buildOrchestratorCommand(epicIdentifier: string): string {
  return `@orchestrator execute epic ${quoteCopilotArgument(epicIdentifier)}`;
}

export function buildOrchestratorFeatureCommand(identifier: string): string {
  return `@orchestrator execute feature ${quoteCopilotArgument(identifier)}`;
}

export function buildBugToErBridgeCommand(caseId: number): string {
  return `@bug-to-er-bridge case ${String(caseId)}`;
}
